import { useEffect, useState } from 'react';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import About from '@/components/About';
import Services from '@/components/Services';
import CaseStudies from '@/components/CaseStudies';
import Testimonials from '@/components/Testimonials';
import BlogPreview from '@/components/BlogPreview';
import FAQ from '@/components/FAQ';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import ChatWidget from '@/components/ChatWidget';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const [blogsSeeded, setBlogsSeeded] = useState(false);

  useEffect(() => {
    // Seed blogs on first load
    const seedBlogs = async () => {
      try {
        await axios.post(`${API}/seed-blogs`);
        setBlogsSeeded(true);
      } catch (error) {
        // Blogs already seeded or error occurred
      }
    };
    seedBlogs();
  }, [API]);

  return (
    <div data-testid="home-page">
      <Header />
      <Hero />
      <About />
      <Services />
      <CaseStudies />
      <Testimonials />
      <BlogPreview />
      <FAQ />
      <ContactSection />
      <Footer />
      <ChatWidget />
    </div>
  );
};

export default Home;